// dependencies
import { List, fromJS } from "immutable";
import moment from "moment";
import PropTypes from "prop-types";
import React from "react";

// components
import EasyAddForm from "./EasyAddForm";

// utils
import isPlainObject from "../../utils/isPlainObject";

const ReviewFormCard = (props) => {
	const {
		form,
		lockedFields = [],
		editableForm = undefined,
		isEditing = false,
		isNewForm = false,
		isDeleted = false,
		onEdit = () => {},
		onCancel = () => {},
		onSave = () => {},
		onDelete = () => {},
		className = "",
		minimumDueDate,
		invalidMinimumDueDateMessage,
	} = props;

	const immutableForm = isPlainObject(form) ? fromJS(form) : form;
	const immutableLockedFields = isPlainObject(lockedFields) ? fromJS(lockedFields) : lockedFields;

	const dueDateType = immutableForm.get("due_date_types");
	let authorDueDate = immutableForm.get("author_due_date");
	let signerDueDate = immutableForm.get("signer_due_date");

	// format date string to date object for existing forms
	if (dueDateType === "static" && !moment.isMoment(authorDueDate)) {
		authorDueDate = moment(authorDueDate);
		signerDueDate = moment(signerDueDate);
	}

	// convert relative signer due date relative to days from author due date
	else if (dueDateType === "relative") {
		signerDueDate -= authorDueDate;
	}
	return (
		<EasyAddForm
			isEditing={isEditing}
			isDeleted={isDeleted}
			editableForm={editableForm}
			onEdit={onEdit}
			onCancel={onCancel}
			onSave={onSave}
			onDelete={onDelete}
			isNewForm={isNewForm}
			className={className}
			isActive={immutableForm.get("is_active")}
			name={immutableForm.getIn(["formObject", "name"], "")}
			authors={immutableForm.get("who_can_add_form")}
			subject={immutableForm.get("subject_employee_choose_author")}
			signers={immutableForm.get("who_signs_off")}
			redacted={immutableForm.get("redact")}
			dueDateType={immutableForm.get("due_date_types")}
			authorsDueDate={authorDueDate}
			signersDueDate={signerDueDate}
			visibleToSubject={immutableForm.get("visibility")}
			allowComments={immutableForm.get("allow_comments")}
			unsaved={immutableForm.get("unsaved", false)}
			approval={immutableForm.get("requiresApproval", null)}
			lockedFields={immutableLockedFields}
			minimumDueDate={minimumDueDate}
			invalidMinimumDueDateMessage={invalidMinimumDueDateMessage}
		/>
	);
};

ReviewFormCard.propTypes = {
	form: PropTypes.object.isRequired,
	/** the selected form for the dropdown. If this value is `undefined`, then
	 * the dropdown is not displayed. This can also be null if nothing is
	 * selected. */
	editableForm: PropTypes.exact({
		_id: PropTypes.string,
		name: PropTypes.string,
	}),
	lockedFields: PropTypes.oneOfType([PropTypes.instanceOf(List), PropTypes.array]),
	isEditing: PropTypes.bool,
	onEdit: PropTypes.func,
	onCancel: PropTypes.func,
	className: PropTypes.string,
	onSave: PropTypes.func,
	onDelete: PropTypes.func,
	/** Indicates if a form is newly added and not yet saved */
	isNewForm: PropTypes.bool,
	isDeleted: PropTypes.bool,
	minimumDueDate: PropTypes.instanceOf(moment),
	invalidMinimumDueDateMessage: PropTypes.string,
};

export default ReviewFormCard;
